import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { changeJobSetupQualificationStatus, fetchDepartments, fetchDesignations, fetchJobSetupQualifications, fetchQualifications, fetchRoles, saveJobSetupQualification } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Qualification = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    job_setup_qualifications,
    designations,
    departments,
    qualifications,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    job_setup_qualifications: state.RecruitmentQualiReducer?.job_setup_qualifications ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    qualifications: state.QualificationMaster?.qualifications ?? [],

    loading: state.RecruitmentQualiReducer?.loading || state.DesignationMaster?.loading || state.DepartmentMaster?.loading || state.QualificationMaster?.loading,
    error: state.RecruitmentQualiReducer?.error || state.DesignationMaster?.error || state.DepartmentMaster?.error || state.QualificationMaster?.error,
    success: state.RecruitmentQualiReducer?.success,
  }));

  const roleOptions = designations.map((role) => ({
    value: role.desig_id,
    label: role.designation,
  }));

  const departmentOptions = departments.map((dept) => ({
    value: dept.departmentId,
    label: dept.departmentname,
  }));

  const qualificationOptions = qualifications.map((quali) => ({
    value: quali.Quali_id,
    label: quali.Qualific_Name,
  }));

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);


  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchJobSetupQualifications(unitId));
    dispatch(fetchDesignations(unitId))
    dispatch(fetchDepartments(unitId))
    dispatch(fetchQualifications(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchJobSetupQualifications(authDetails?.unit_id));
      setIsEdit(false);
      setEditId(null);
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: "",
      role: "",
      Qualification: [],
    },
    validationSchema: Yup.object({
      department: Yup.object().required("Please select a department"),
      role: Yup.object().required("Please select a role"),
      Qualification: Yup.array()
        .of(
          Yup.object({
            value: Yup.string().required(),
            label: Yup.string().required(),
          })
        )
        .min(1, "Please select at least one qualification")
        .required("Please select a qualification"),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = new FormData();
      payload.append("mq_id", isEdit ? editId : 0);
      payload.append("dept_id", values.department?.value);
      payload.append("role_id", values.role?.value);
      payload.append(
        "qualification",
        Array.isArray(values.Qualification)
          ? values.Qualification.map(q => q.value).join(',')
          : ''
      );
      payload.append("unit_id", authDetails?.unit_id);
      payload.append("create_by", authDetails?.user_id);
      dispatch(saveJobSetupQualification(payload))
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.mq_id);
    const departmentObj = departments.find(
      emp => emp.departmentId === row.dept_id
    );
    const roleObj = designations.find(
      r => r.desig_id === row.role_id
    );
    const selectedQualIds = row.qualication_id.split(',').map(id => parseInt(id.trim()));
    const selectedQualifications = qualificationOptions.filter(q => selectedQualIds.includes(q.value));
    formik.setValues({
      department: {
        value: departmentObj?.departmentId,
        label: departmentObj?.departmentname
      },
      role: {
        value: roleObj?.desig_id,
        label: roleObj?.designation
      },
      Qualification: selectedQualifications,
    });
  };

  // const columns = [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => {
  //       const { b_active, mq_id } = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //           <Link
  //             to="#"
  //             style={{ color: isActive ? "green" : "red" }}
  //             onClick={() => handleToggleStatus(cellProps.row.original, isActive)}
  //           >
  //             <i
  //               className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
  //               id={`status-tooltip-${cellProps.row.id}`}
  //             />
  //             <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //               {isActive ? "Mark Inactive" : "Mark Active"}
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => job_setup_qualifications.length - row.index,
  //     className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   { Header: "Department", accessor: "department" },
  //   { Header: "Role", accessor: "role" },
  //   { Header: "Qualification", accessor: "qualifications" },
    
  // ];

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "S.No",
        Cell: ({ row }) => job_setup_qualifications.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Department", accessor: "department" },
      { Header: "Role", accessor: "role" },
      { Header: "Qualification", accessor: "qualifications" },
    ];

    // 👉 Only show Action column if any permission exists
    if (canEdit || canDelete) {
      baseColumns.unshift({
        Header: "Action",
        Cell: (cellProps) => {
          const { b_active } = cellProps.row.original;
          const isActive = b_active === 1;
          const tooltipId = `action-${cellProps.row.index}`;

          return (
            <div className="d-flex gap-3">

              {/* ✏️ Edit Button */}
              {canEdit && (
                <Link
                  to="#"
                  className="text-success"
                  onClick={() => handleEdit(cellProps.row.original)}
                >
                  <i
                    className="bx bxs-edit font-size-18"
                    id={`edit-${tooltipId}`}
                  />
                  <UncontrolledTooltip placement="top" target={`edit-${tooltipId}`}>
                    Edit
                  </UncontrolledTooltip>
                </Link>
              )}

              {/* 🔄 Active/Inactive Toggle */}
              {canDelete && (
                <Link
                  to="#"
                  style={{ color: isActive ? "green" : "red" }}
                  onClick={() => handleToggleStatus(cellProps.row.original, isActive)}
                >
                  <i
                    className={`mdi ${
                      isActive ? "mdi-check-circle" : "mdi-close-circle"
                    } font-size-18`}
                    id={`toggle-${tooltipId}`}
                  />
                  <UncontrolledTooltip placement="top" target={`toggle-${tooltipId}`}>
                    {isActive ? "Mark Inactive" : "Mark Active"}
                  </UncontrolledTooltip>
                </Link>
              )}

            </div>
          );
        },
      });
    }

    return baseColumns;
  }, [job_setup_qualifications, canEdit, canDelete]);


  const handleToggleStatus = (row, isActive) => {
    const { bactive, mq_id, dept_id, role_id } = row;
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("mq_id", mq_id);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(changeJobSetupQualificationStatus(formData));
      }
    });
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 42,
      minHeight: 42,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Setup" breadcrumbItem="Qualifications Mapping" />
        {(canCreate || canEdit) && (
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-3 ">
                <Col md="4">
                  <FormGroup>
                    <Label>Department <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="department"
                      name="department"
                      options={departmentOptions}
                      // value={departmentOptions.find(option => option.value === formik.values.department) || null}
                      value={formik.values.department}
                      onChange={selectedOption => formik.setFieldValue("department", selectedOption)}
                      onBlur={() => formik.setFieldTouched("department", true)}  // ✅ Ensure onBlur is handled
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                      isDisabled={isEdit}
                    />
                    {formik.touched.department && formik.errors.department ? (
                      <div className="text-danger">{formik.errors.department}</div>
                    ) : null}

                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label>Role <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="role"
                      name="role"
                      options={roleOptions}
                      // value={roleOptions.find(option => option.value === formik.values.role) || null}
                      value={formik.values.role}
                      onChange={selectedOption => formik.setFieldValue("role", selectedOption)}
                      onBlur={() => formik.setFieldTouched("role", true)}  // ✅ Ensure onBlur is handled
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                      isDisabled={isEdit}
                    />
                    {formik.touched.role && formik.errors.role ? (
                      <div className="text-danger">{formik.errors.role}</div>
                    ) : null}

                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <Label>Qualification <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="Qualification"
                      name="Qualification"
                      options={qualificationOptions}
                      isMulti
                      // value={qualificationOptions.filter(option => formik.values.Qualification?.includes(option.value)) || []}
                      value={formik.values.Qualification}
                      onChange={selectedOptions =>
                        formik.setFieldValue("Qualification", selectedOptions || [])
                      }
                      onBlur={() => formik.setFieldTouched("Qualification", true)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />

                    {formik.touched.Qualification && formik.errors.Qualification ? (
                      <div className="text-danger">{formik.errors.Qualification}</div>
                    ) : null}


                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className="mob-center text-end">
                  <Button type="submit" className="btn button-save me-2 mt-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button" color="secondary"
                    onClick={() => {
                      formik.handleReset(); // reset the form
                      setIsEdit(false);     // set isEdit to false
                    }} className="btn button-cancel mt-2"> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        )}
        <Card>
          <CardBody>
            <TableContainer columns={columns} data={job_setup_qualifications.length > 0 ? job_setup_qualifications : []} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Qualification;
